<template>
  <div>
    <h5 class="font-weight-bold">End of Employee Contract Period</h5>
    <br>
    <b-row v-show="!employeesApproachingContractEnd.length">
      <b-col>
        <div align="center">
          <img src="@/assets/icon-no-invoice.png"/>
        </div>
      </b-col>
    </b-row>
    <b-table
      ref="table"
      class="mt-2 p-2"
      v-show="employeesApproachingContractEnd.length"
      :fields="fields"
      :items="employeesApproachingContractEnd"
      :per-page="perPage"
      :current-page="currentPage"
      :sort-by.sync="sortBy"
      sort-icon-left
      striped
      responsive
    >
      <template #cell(employee-number)="{ employee }">
        {{ employee.employeeNo }}
      </template>
      <template #cell(full-name)="{ employee }">
        {{ employee.fullName }}
      </template>
      <template #cell(hire-date)="{ employee }">
        {{ formatDate(employee.hireDate) }}
      </template>
      <template #cell(resign-date)="{ employee }">
        {{ formatDate(employee.resignDate) }}
      </template>
    </b-table>
  </div>
</template>

<script>

export default {
  props: {
    contractProbationEmployee: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    sortBy: 'fullName',
    employee: [],
    filter: ['Active'],
    currentPage: 1,
    perPage: 10,
    totalRows: 0,
    totalPage: 0,
    pageOptions: [10, 20, 50, 100],
    fields: [
      { key: 'employeeNo', label: 'Id', tdClass: 'text-center', thClass: 'text-center ' },
      { key: 'fullName', label: 'Full Name', tdClass: 'text-center', thClass: 'text-center', sortable: true },
      { key: 'hireDate', label: 'Hire Date', tdClass: 'text-center', thClass: 'text-center' },
      { key: 'resignDate', label: 'End Date', tdClass: 'text-center', thClass: 'text-center' }
    ]
  }),
  watch: {
    contractProbationEmployee: {
      handler() {
        this.employee = this.sortByName(this.deleteRowVariant(this.contractProbationEmployee))
      },
      immediate: true
    }
  },
  computed: {
    employeesApproachingContractEnd() {
      const currentDate = new Date()
      const endDateThreshold = new Date()
      endDateThreshold.setDate(endDateThreshold.getDate() + 30)
      const list = []

      this.employee.forEach((employee, i) => {
        const resignDate = new Date(employee.resignDate)
        if (resignDate > currentDate && resignDate <= endDateThreshold) {
          list.push({
            employeeNo: employee.employeeNo,
            fullName: employee.fullName,
            hireDate: employee.hireDate,
            resignDate: employee.resignDate
          })
        }
      })
      list.map((item, i) => {
        item._rowVariant = i % 2 === 0 ? 'warning' : ''
      })
      return list
    }
  },
  methods: {
    defaultDateFormated() {
      const customDate = new Date(1, 0, 1, 0, 0, 0)
      const month = (customDate.getMonth() + 1).toString().padStart(2, '0')
      const day = customDate.getDate().toString().padStart(2, '0')
      const hours = customDate.getHours().toString().padStart(2, '0')
      const minutes = customDate.getMinutes().toString().padStart(2, '0')
      const seconds = customDate.getSeconds().toString().padStart(2, '0')

      const formattedDate = `0001-${month}-${day} ${hours}:${minutes}:${seconds}`
      return formattedDate
    },
    formatedDate(date) {
      const dateInput = new Date(date)
      dateInput.setDate(date.getDate() + 30)
      return dateInput
    },
    deleteRowVariant(arr) {
      return arr.map(obj => {
        const { _rowVariant, ...rest } = obj
        return rest
      })
    },
    sortByName(arr) {
      return arr.sort((a, b) => {
        const nameA = a.fullName.toUpperCase()
        const nameB = b.fullName.toUpperCase()
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        return 0
      })
    }
  }
}
</script>
